"use client";

import queryClient from "@/lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./ui/sonner";
import { GlobalModal } from "./GlobalModal";
import ConfirmationDialog from "./confirmation-dialog";
import GoogleAnalytics from "./GoogleAnalytics";
import { ThemeProvider } from "next-themes";

function Provider({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
      <QueryClientProvider client={queryClient}>
        <>
          {children}
          <GlobalModal />
          <ConfirmationDialog />
          <Toaster />
          <GoogleAnalytics />
        </>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default Provider;